import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { EmailLink } from '../../EmailLink';
import { PhoneCallLink } from '../../PhoneCallLink';

interface MapContactCardProps {
  name?: string;
  role?: string;
  phone?: string;
  email?: string;
  onEmailClick?: () => void;
}

export function MapContactCard({ name, role, phone, email, onEmailClick }: MapContactCardProps) {
  return (
    <div className="flex flex-col gap-0.5 py-1">
      {name && <div className="text-sm font-medium text-slate-900">{name}</div>}
      {role && <div className="text-xs text-slate-500">{role}</div>}
      <div className="flex flex-col gap-0.5 mt-0.5">
        {phone && (
          <PhoneCallLink phone={phone} whenNoLink="text" className="inline-flex items-center gap-1 text-xs text-sky-600 hover:text-sky-800" aria-label={`Call ${name}`}>
            <Phone className="w-3 h-3" /> {phone}
          </PhoneCallLink>
        )}
        {email && onEmailClick ? (
          <button onClick={onEmailClick} className="inline-flex items-center gap-1 text-xs text-sky-600 hover:text-sky-800 text-left" aria-label={`Email ${name}`}>
            <Mail className="w-3 h-3 flex-shrink-0" /> {email}
          </button>
        ) : email ? (
          <EmailLink email={email} className="inline-flex items-center gap-1 text-xs text-sky-600 hover:text-sky-800" aria-label={`Email ${name}`}>
            <Mail className="w-3 h-3 flex-shrink-0" /> {email}
          </EmailLink>
        ) : null}
      </div>
    </div>
  );
}
